export const ArrowIcon = () => (
  <SVG size={16}>
    <path d="M3 5L8 10L13 5H3Z" />
  </SVG>
);

export const CalendarIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.995 2V4H7.995V2H5.995V4H3.005V22H20.995V4H17.995V2H15.995ZM16.995 13H11.995V18H16.995V13ZM4.995 20H18.995V9H4.995V20Z"
    />
  </SVG>
);

export const CloseIcon = () => (
  <SVG size={24}>
    <path d="M20 5.4L18.6 4L12 10.6L5.4 4L4 5.4L10.6 12L4 18.6L5.4 20L12 13.4L18.6 20L20 18.6L13.4 12L20 5.4Z" />
  </SVG>
);

export const ChevronIcon = () => (
  <SVG size={16}>
    <path d="M15.2 5.2L13.8 3.8L8.2 9.4L2.6 3.8L1.2 5.2L8.2 12.2L15.2 5.2Z" />
  </SVG>
);

export const DownloadIcon = () => (
  <SVG size={16}>
    <path d="M14 14H2H0V16H2H14H16V14H14Z" />
    <path d="M13 7L11.6 5.6L9 8.2V0H7V8.2L4.4 5.6L3 7L8 12L13 7Z" />
  </SVG>
);

export const EmailIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00488 4H21.9949V20H2.00488V4ZM11.9949 13L19.9949 8V6L11.9949 11L3.99488 6V8L11.9949 13Z"
    />
  </SVG>
);

export const ClearIcon = () => (
  <SVG size={24}>
    <path
      clipRule="evenodd"
      d="M2 12C2 6.47 6.47 2 12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.47 22 2 17.53 2 12ZM15.59 17L17 15.59L13.41 12L17 8.41L15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17Z"
      fillRule="evenodd"
    />
  </SVG>
);

export const ExternalIcon = () => (
  <SVG size={16}>
    <path d="M8.8996 0V2H12.5996L5.59961 9.00039L6.99961 10.4004L13.9996 3.4V7.1H15.9996V0H8.8996Z" />
    <path d="M12 14H2V4H5V2H0V16H14V11H12V14Z" />
  </SVG>
);

export const LocationIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 9.35C5 5.2865 7.9365 2 12 2C16.0635 2 19 5.2865 19 9.35C19 14.8625 12 22 12 22C12 22 5 14.8625 5 9.35ZM9 9C9 10.656 10.344 12 12 12C13.656 12 15 10.656 15 9C15 7.344 13.656 6 12 6C10.344 6 9 7.344 9 9Z"
    />
  </SVG>
);

export const MenuIcon = () => (
  <SVG size={24}>
    <path d="M22 4H2V6H22V4Z" />
    <path d="M22 18H2V20H22V18Z" />
    <path d="M16 11H2V13H16V11Z" />
  </SVG>
);

export const PhoneIcon = () => (
  <SVG size={24}>
    <path d="M2.99997 3H7.99997L8.99997 8L6.99997 10C8.19997 14 12.1666 16.3333 14 17L16 15L21 16V21C5.79997 21 2.66663 9 2.99997 3Z" />
  </SVG>
);

export const SearchIcon = () => (
  <SVG size={24}>
    <path d="M16.3 14.9C17.3 13.6 18 11.9 18 10C18 5.6 14.4 2 10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18C11.8 18 13.5 17.4 14.9 16.3L20.6 22L22 20.6L16.3 14.9ZM10 16C6.7 16 4 13.3 4 10C4 6.7 6.7 4 10 4C13.3 4 16 6.7 16 10C16 11.3 15.6 12.5 14.9 13.5C14.5 14 14 14.5 13.5 14.9C12.5 15.6 11.3 16 10 16Z" />
  </SVG>
);

export const WebsiteIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 9.948 3.948 8 6 8H11V6H6C2.688 6 0 8.688 0 12C0 15.312 2.688 18 6 18H11V16H6C3.948 16 2 14.052 2 12ZM7 13H17V11H7V13ZM13 6H18C21.312 6 24 8.688 24 12C24 15.312 21.312 18 18 18H13V16H18C20.052 16 22 14.052 22 12C22 9.948 20.052 8.03 18 8.03H13V6Z"
    />
  </SVG>
);

export const CheckIcon = () => (
  <SVG size={24}>
    <path d="M8.4 19.95L1.5 13.05L4.5 10.2L8.4 14.1L19.5 3L22.5 6L8.4 19.95Z" />
  </SVG>
);

export const BlockQuoteIcon = () => (
  <SVG size={24}>
    <path d="M13.925 19h8.243v-6.957h-3.155c-.254-2.478 1.476-4 4.987-4.304L23.339 5c-6.056.087-9.414 2.391-9.414 8.13V19zM1 19h8.243v-6.957H6.09c-.255-2.478 1.475-4 4.986-4.304L10.414 5C4.358 5.087 1 7.391 1 13.13V19z" />
  </SVG>
);

export const SpinnerIcon = () => (
  <SVG size={24}>
    <path d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z" />
  </SVG>
);

export const LinkedInIcon = () => (
  <SVG size={24}>
    <path d="M20.5714 2H3.42411C2.63839 2 2 2.64732 2 3.44196V20.558C2 21.3527 2.63839 22 3.42411 22H20.5714C21.3571 22 22 21.3527 22 20.558V3.44196C22 2.64732 21.3571 2 20.5714 2ZM8.04464 19.1429H5.08036V9.59821H8.04911V19.1429H8.04464ZM6.5625 8.29464C5.61161 8.29464 4.84375 7.52232 4.84375 6.57589C4.84375 5.62946 5.61161 4.85714 6.5625 4.85714C7.50893 4.85714 8.28125 5.62946 8.28125 6.57589C8.28125 7.52679 7.51339 8.29464 6.5625 8.29464ZM19.1562 19.1429H16.192V14.5C16.192 13.3929 16.1696 11.9688 14.6518 11.9688C13.1071 11.9688 12.8705 13.1741 12.8705 14.4196V19.1429H9.90625V9.59821H12.75V10.9018H12.7902C13.1875 10.1518 14.1563 9.36161 15.5982 9.36161C18.5982 9.36161 19.1562 11.3393 19.1562 13.9107V19.1429Z" />
  </SVG>
);

export const TwitterIcon = () => (
  <SVG size={24}>
    <path d="M19.9442 7.98749C19.9569 8.16248 19.9569 8.33751 19.9569 8.5125C19.9569 13.85 15.8326 20 8.29444 20C5.97209 20 3.81473 19.3375 2 18.1875C2.32996 18.225 2.64719 18.2375 2.98985 18.2375C4.90607 18.2375 6.67006 17.6 8.0787 16.5125C6.27666 16.475 4.76649 15.3125 4.24618 13.7125C4.50001 13.75 4.7538 13.775 5.02032 13.775C5.38833 13.775 5.75638 13.725 6.099 13.6375C4.22083 13.2625 2.81215 11.6375 2.81215 9.67499V9.62501C3.35782 9.92501 3.99239 10.1125 4.66493 10.1375C3.56087 9.41247 2.83754 8.17498 2.83754 6.77497C2.83754 6.02499 3.04055 5.33749 3.3959 4.73748C5.41369 7.18748 8.44671 8.78745 11.8477 8.96248C11.7843 8.66248 11.7462 8.35001 11.7462 8.03751C11.7462 5.81248 13.5736 4 15.8452 4C17.0254 4 18.0914 4.4875 18.8401 5.275C19.7665 5.10001 20.6548 4.76249 21.4416 4.3C21.137 5.23752 20.4898 6.02502 19.6396 6.52499C20.4645 6.43753 21.264 6.21248 22 5.90001C21.4417 6.69998 20.7437 7.41245 19.9442 7.98749Z" />
  </SVG>
);

export const YoutubeIcon = () => (
  <SVG size={24}>
    <path d="M22.5403 6.50346C22.2873 5.51804 21.5418 4.74196 20.5953 4.47858C18.8796 4 12 4 12 4C12 4 5.12044 4 3.40474 4.47858C2.45821 4.742 1.71273 5.51804 1.45971 6.50346C1 8.28958 1 12.0162 1 12.0162C1 12.0162 1 15.7428 1.45971 17.5289C1.71273 18.5143 2.45821 19.258 3.40474 19.5214C5.12044 20 12 20 12 20C12 20 18.8796 20 20.5953 19.5214C21.5418 19.258 22.2873 18.5143 22.5403 17.5289C23 15.7428 23 12.0162 23 12.0162C23 12.0162 23 8.28958 22.5403 6.50346ZM10 15.5V12.3835V9L15.5 12L10 15.5Z" />
  </SVG>
);

export const PlayIcon = () => (
  <SVG size={36}>
    <path d="M10 5v26l20-13L10 5z" />
  </SVG>
);

export const SVG = ({ children, size }) => (
  <svg
    fill="currentColor"
    viewBox={`0 0 ${size} ${size}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);
